import request from "@assets/js/axios";
const { instance: $axios } = request;
class Visa {
  constructor() {}
  addOrder(data) {
    return $axios.post("/VisaOrder/store", data);
  }
  // 签证各洲城市
  getCountry() {
    return $axios.get("/homeByIp");
  }
  // 获取搜索列表参数
  getSearchData() {
    return $axios.get("/VisaOrder/commonBase");
  }
  // 获取签证列表
  list(data) {
    return $axios.get("/VisaOrder/getOrdersByUser", { params: data });
  }
  // 签证详情
  detail(OrderNO) {
    return $axios.get("/VisaOrder/getOrderByUser", { params: { OrderNO } });
  }
  // 支付结果
  payResult(OrderNO) {
    return $axios.get("/VisaOrder/getOrderPayStatus", { params: { OrderNO } });
  }
  // 支付信息
  payInfo(OrderNO) {
    return $axios.get("/Yspay/request", { params: { payment_type: 'YspayAlipay', order_type: 'visa', order_sn: OrderNO } })
  }
  // 获取订单来源列表
  visCache () {
    return $axios.get('/home/visCache');
  }
  // 根据手机获取用户信息
  getCustomerByphone (phone) {
    return $axios.get(`user/getCustomerByphone?phoneNumber=${phone}`)
  }
}

export default new Visa();
